var __P = 'prototype';
var __C = 'constructor';
var __CL = '__CLASS';

window.DR = window.DR || {};

DR.URL = '/api/rpc.php';

DR._Base = function Base(){
};

DR._Base.is = function(v){
	return v !== null && typeof v != 'undefined';
};

DR._Base.hsd = function(string){
	return String(string).replace( /&lt;/g, '<' ).replace( /&gt;/g, '>' ).replace(/&nbsp;/g, ' ').replace( /&quot;/g, '"' ).replace( /&amp;/g, '&' );
};

DR._Base.strip_tags = function(html){
	let tmp = document.createElement('div');
	tmp.innerHTML = html;
	return tmp.textContent || tmp.innerText || '';
};

DR._Base.decode = function(s){
	// parse nelietojam, jo dažus JSON nevar atserializēt
	try{
		return !( /[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test( s.replace(/"(\\.|[^"\\])*"/g, '')) ) && eval( '(' + s + ')' );
	}
	catch(e){
		return false;
	}
};

DR._Base.uniqueValues = function(a){
	let o = {};
	let k;
	for( k in a ){
		o[ a[k] ] = true;
	}
	let re = [];
	for( k in o ){
		re.push(k);
	}
	return re;
};

DR._Base._types = {};
DR._Base._ = {};
DR._Base.select = {};

DR._Base.cast = function(par){
	if(!par){
		return null;
	}
	if( this._types[ par._t ] ){
		return new this._types[ par._t ](par);
	}
	if( window.console ) console.warn( 'Undefined type ' + par._t + '; Check your API SDK version!!!' );
	return null;
};

DR._Select = function Select(){
};

DR._Select.prototype._fields = [];

DR._Select.prototype._getName = function(){
	return this.constructor[__CL];
};

DR._Select.prototype._getFields = function(){
	let re = [];
	for( let k in this._fields ){
		if( this._fields[k] ){
			re.push(k);
		}
	}
	return re;
};

DR._Select.prototype.all = function(v){
	for( let k in this ){
		if( k !== 'all' && k[0] !== '_' && this[k] instanceof Function ){
			this[k](v);
		}
	}
	return this;
};

DR._Select.prototype.__noSuchMethod__ = function(id){
	window.console && console.warn( 'undefined select field:' + id, this );
	return this;
};

DR._Method = function Method(){
};

/**
* @param {Array.<DR._Select>} [select]
* @returns {Array}
*/
DR._Method.prototype.toApi = function(select){
	let sel = {};
	let k, r;
	if(select){
		for( k in select ){
			r = select[k];
			if( !( r instanceof DR._Select ) ){
				window.console && console.warn( 'select not instanceof DR._Select', r );
				continue;
			}
			sel[ r._getName() ] = r._getFields();
		}
	}
	for( k in this.select ){
		r = this.select[k];
		if( !( r instanceof DR._Select ) ){
			window.console && console.warn( 'select not instanceof DR._Select', r );
			continue;
		}
		let name = r._getName();
		if( sel[name] ){
			sel[name] = DR._Base.uniqueValues( sel[name].concat( r._getFields() ) );
		} else {
			sel[name] = r._getFields();
		}
	}
	let data = {};
	for( k in this ){
		if(
			k === 'select' ||
			k === 'error' ||
			k === 're' ||
			k === 'processing' ||
			k === 'onLoad' ||
			k === 'onError' ||
			k === 'onErrorAutoDisabled'
		){ // reserved kw
			continue;
		}
		data[k] = this[k];
	}
	return [ this.constructor[__CL], data,  sel ];
};

DR._Method.prototype.error = null;
/** @type {Array.<DR._Select>} */
DR._Method.prototype.select = null;
/** @type {Function} */
DR._Method.prototype.onLoad = null;
/** @type {Function} */
DR._Method.prototype.onError = null;
DR._Method.prototype.onErrorAutoDisabled = false;
DR._Method.prototype.processing = false;

DR._Method.prototype._re = function(par){
	this.re = DR._Base.cast(par);
};

/**
 * @typedef {{eventId:int, eventSeoTitle:string}} DApiCall
 */

/**
 * @param {DApiCall} [par]
 */
DR._Method.prototype.call = function(par){
	new DR.ApiCall( {
		methods:[this]
	} ).call(par);
};

// ++++ API CALL +++

DR.ApiCallPar = function(){
};

DR.ApiCallPar.prototype = {
	/** @type {Array.<DR._Method>} */
	methods:[],
	/** @type {Array.<DR._Select>} */
	select:[],
	/** @type function */
	onLoad:null,
	/** @type function */
	onClosed:null,
	context:null
};

DR.ApiCall = function ApiCall(par){
	par = par || {};
	/** @type {Array.<DR._Method>} */
	this.methods = par.methods || [];
	/** @type {Array.<DR._Select>} */
	this.select = par.select || [];
	this.onLoad = par.onLoad || this.onLoad;
	this.onClosed = par.onClose || this.onClosed;
	this.context = par.context || null;
	this._deferred = 0;
	this._waitingOnDeferred = false;
};

DR.ApiCall.prototype.addMethod = function( method ){
	if( !( method instanceof DR._Method ) ){
		window.console && console.warn( 'method type', method );
		return;
	}
	this.methods.push(method);
};

/**
 * Set to make .call wait for an async function to complete
 * stop waiting by calling .deferResolve
 */
DR.ApiCall.prototype.defer = function(){
	++this._deferred;
};

DR.ApiCall.prototype.deferResolve = function(){
	--this._deferred;
	if( !this._deferred && this._waitingOnDeferred ) {
		this._waitingOnDeferred = false;
		this.call();
	}
};

DR.ApiCall.prototype.onLoad = function(){};
DR.ApiCall.prototype.onBeforeLoad = function(){};
DR.ApiCall.prototype.onClosed = function(){};

/**
 * @param {DApiCall} [par]
 */
DR.ApiCall.prototype.call = function(par){
	par = par || {};
	if( !DR.URL ){
		throw 'DR.URL not configured!';
	}
	if( this._deferred > 0 ) {
		this._waitingOnDeferred = true;
		return;
	}
	let rq = [];
	let methodNames = [];
	for( let k = 0; k < this.methods.length; k++ ){
		if( !( this.methods[k] instanceof DR._Method ) ){
			window.console && console.warn( 'method not instanceof DR._Method', this.methods[k] );
			continue;
		}
		if( this.methods[k].processing ){
			window.console && console.warn( 'method in progress', this.methods[k] );
			continue;
		}
		this.methods[k].processing = true;
		let a = this.methods[k].toApi( this.select );
		rq.push(a);
		methodNames.push( a[0] );
	}
	let g = [ 'm=' + methodNames.join(',') ];
	if( par.eventId ){
		g.push('eventId=' + par.eventId);
	}
	if( par.eventSeoTitle ) {
		g.push('eventSeoTitle=' + par.eventSeoTitle);
	}
	if( location.href.indexOf('XDEBUG_PROFILE=1') !== -1 ){
		g.push( 'XDEBUG_PROFILE=1' );
	}
	const xhr = new XMLHttpRequest();
	xhr.open('POST', DR.URL + '?' + g.join('&'), this.async);
	xhr.setRequestHeader('Content-Type', 'application/json');
	xhr.setRequestHeader('X-Requested-With', 'api');
	xhr.setRequestHeader('ROADGAMES-LANG', D.LANG);
	xhr.onreadystatechange = function() {
		if (xhr.readyState === XMLHttpRequest.DONE) {
			if (xhr.status === 200) {
				this._call(xhr.responseText);
			} else if (xhr.status === 302) {
				// auto login, require reload
				D.reload();
			} else {
				this._error('rq');
			}
		}
	}.bind(this);
	xhr.send(JSON.stringify(rq, null, (window.DEV ? '\t' : '')));
};

DR.ApiCall.prototype._call = function(resp){
	let re;
	try{
		re = DR._Base.decode(resp);
	} catch(e){
		window.console && console.error( 'JSON.parse', DR._Base.strip_tags(resp) );
		return;
	}
	let errObject =  re[ re.length - 1 ];
	if(errObject){
		if( errObject.ob ){
			window.console && console.info( DR._Base.strip_tags(errObject.ob) );
		}
		if( errObject.error ){
			window.console && console.info( errObject.error );
			this._error( errObject.error );
			return;
		}
	}
	this.onBeforeLoad.call( this.context || this );
	let authError = false;
	let closedError = false;
	let verifyEmailError = false;
	let setEmailError = false;
	for( let i = 0; i < re.length - 1; ++ i ){
		let r = re[i];
		let m = this.methods[i];
		let err = r[1];
		if(err){
			if(!m.onErrorAutoDisabled) {
				if( err === 'auth' ){
					authError = true;
				}
				if( err === 'closed' || err === 'down' ){
					closedError = true;
				}
				if( err === 'verify email' ) {
					verifyEmailError = true;
				}
				if( err === 'set email' ) {
					setEmailError = true;
				}
			}
			window.console && console.warn( err, m );
			m.error = err;
			if( m.onError instanceof Function ){
				m.onError();
			}
			continue;
		}
		m._re( r[0] );
		if( m.onLoad instanceof Function ){
			m.onLoad();
		}
	}
	if(authError){
		D.reload();
		return;
	}
	if(closedError){
		this.onClosed.call( this.context || this );
	} else {
		this.onLoad.call( this.context || this );
	}
	if( setEmailError ){
		Section.navigate(D.url('/verify-email/empty'));
		return;
	} else if( verifyEmailError ){
		Section.navigate(D.url('/verify-email'));
		return;
	}
	for( let k = 0; k < this.methods.length; k++ ){
		this.methods[k].processing = false;
	}
	this.methods = [];
};

DR.ApiCall.prototype._error = function(error){
	for( let k = 0; k < this.methods.length; k++ ){
		let m = this.methods[k];
		m.error = error;
		m.processing = false;
		if( m.onError instanceof Function ){
			m.onError();
		}
	}
	this.methods = [];
	this.onLoad.call( this.context || this );
};


DR.ApiCall.prototype.async = true;
